// extracted by mini-css-extract-plugin
module.exports = {"meaning":"Meanings_meaning__1QKd1","titles":"Meanings_titles__j-TFF","definitions":"Meanings_definitions__3UrC_","examples":"Meanings_examples__1iCv1"};